import { Star } from "lucide-react";
import { useAuth } from "../lib/auth";
import { useReview, toggleStar } from "../lib/review";

export function LockStar({ id, className = "" }) {
  const { user } = useAuth() || {};
  const { on, keys } = useReview();
  if (!on || user?.role !== "agency_owner") return null;
  const locked = keys.has(id);
  const click = (e) => { e.preventDefault(); e.stopPropagation(); toggleStar(id); };
  return (
    <span role="button" tabIndex={0} onClick={click} onKeyDown={(e) => e.key === "Enter" && click(e)} title={locked ? "Locked in - click to undo" : "Click to lock this in"}
      className={`inline-grid h-5 w-5 shrink-0 cursor-pointer place-items-center rounded-full transition-[opacity,transform] duration-200 hover:scale-125 ${locked ? "opacity-100" : "opacity-35 hover:opacity-80"} ${className}`}
      data-testid={`lock-star-${id.replace(/[^a-z0-9]+/gi, "-").toLowerCase()}`} data-locked={locked ? "true" : "false"}>
      <Star className="h-3.5 w-3.5" strokeWidth={1.6} style={{ color: "#D9B95C", fill: locked ? "#D9B95C" : "transparent", filter: locked ? "drop-shadow(0 0 4px rgba(217,185,92,0.6))" : "none" }} />
    </span>
  );
}
